import React, { useState } from "react";
import {
  StyleSheet,
  Image,
  Text,
  View,
  Dimensions,
  SafeAreaView,
  StatusBar,
  ImageBackground,
  Button,
  TouchableWithoutFeedback,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { TouchableOpacity } from "react-native-gesture-handler";
import Svg, { Path } from "react-native-svg";
import WavyHeader from "./WavyHeader";
const Home = (props) => {
  const [selected, setSelected] = useState("BookCollection");

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar
        barStyle="dark-content"
        hidden={false}
        backgroundColor="#E0E6FE"
        translucent={false}
        networkActivityIndicatorVisible={true}
        animated={true}
      />
      <View style={styles.header}>
        <Image source={require("../img/1.png")} style={styles.img} />
        <Image source={require("../img/logo.png")} style={styles.imge} />
      </View>
      <Text style={styles.title}>BOSAD REFERENCES</Text>
      <Text style={styles.disclaimer}>
        Disclaimer: The information provided in this app is intended for
        informational purposes only and should not be construed as a substitute
        for professional medical advice. Always consult with a qualified
        healthcare professional before making any decisions about your health or
        treatment plan. For a complete list of references used in this app,
        please see the "References" section at the end.
      </Text>

      <View style={styles.btn}>
        <TouchableWithoutFeedback
          onPress={() => props.navigation.navigate("BookCollection")}
        >
          <View
            style={{
              paddingHorizontal: 50,
              paddingVertical: 9,
              margin: 9,
              // padding: 10,
              backgroundColor: "#5c5de5",
              borderRadius: 10,
              elevation: 5,
            }}
          >
            <Text style={{ fontSize: 13, color: "white" }}>Start</Text>
          </View>
        </TouchableWithoutFeedback>
      </View>
      {/* <WavyHeader customStyles={styles.svgCurve} /> */}
    </SafeAreaView>
  );
};

export default Home;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    // justifyContent: "center",
    backgroundColor: "#E0E6FE",
  },
  img: {
    height: "40%",
    width: "100%",
    // margin: 10,

    // marginTop: 50,

    resizeMode: "contain",
  },
  imge: {
    height: "40%",
    width: "60%",
    // margin: 10,

    // marginTop: 30,
    resizeMode: "contain",
  },
  title: {
    color: "#191919",
    fontSize: 30,
    marginTop: 20,
  },
  disclaimer: {
    color: "#191919",
    fontSize: 13,
    margin: 10,
  },
  detail: {
    color: "#191919",
    fontSize: 18,
    textAlign: "center",
    paddingHorizontal: 20,
    lineHeight: 30,
    marginTop: 30,
  },
  btn: {
    marginTop: 40,
    // marginBottom: 40,
    backgroundColor: "#164863",
    paddingHorizontal: "30%",
    paddingVertical: 20,
    borderTopRightRadius: 40,
    borderTopLeftRadius: 40,
    resizeMode: "contain",
  },
  text: {
    fontSize: 30,
    color: "#fff",
  },
  header: {
    flex: 1,
    alignItems: "center",
    justifyContent: "space-around",
    width: "100%",
    // height: "10%",
    // paddingHorizontal: 70,
    // paddingTop: 30,
  },
  svgCurve: {
    position: "absolute",
    marginTop: 0,
    width: Dimensions.get("window").width,
  },
  background: {
    width: "100%",
    height: "100%",
    flex: 1,
    resizeMode: "cover",
    justifyContent: "center",
  },
});
